<!-- UI-7 A10: navbar language selector (LIS-style country-flag dropdown).
     Data-driven from the locales shipped in lang.js; switching uses the existing
     changeLanguageMixin and persists the choice to localStorage. Adding a language
     later = a new translations.csv column + a locale in lang.js + a flag SVG. -->
<template>
<div class="navbar-item has-dropdown is-hoverable lang-selector">
  <span class="navbar-link" tabindex="0" :title="$t('language')">
    <img class="lang-flag" :src="flagSrc(currentLocale)" :alt="currentLocale">
    <span class="lang-code">{{ currentLocale.toUpperCase() }}</span>
  </span>
  <div class="navbar-dropdown is-right">
    <a
      v-for="lang in languages"
      :key="lang.code"
      class="navbar-item"
      :class="{'is-active': lang.code === currentLocale}"
      @click="select(lang.code)"
    >
      <img class="lang-flag" :src="flagSrc(lang.code)" :alt="lang.code">
      <span>{{ lang.label }}</span>
    </a>
  </div>
</div>
</template>

<script>
import {changeLanguageMixin} from '@/lang.js';

export default {
  name: 'language-selector',
  mixins: [changeLanguageMixin],
  data() {
    return {
      // Endonyms (shown the same regardless of active locale, as is convention for
      // language pickers). Must stay in sync with lang.js `messages`.
      languages: [
        {code: 'en', label: 'English'},
        {code: 'ro', label: 'Română'},
        {code: 'fr', label: 'Français'},
        {code: 'de', label: 'Deutsch'},
        {code: 'id', label: 'Bahasa Indonesia'},
        {code: 'it', label: 'Italiano'},
        {code: 'pt', label: 'Português'},
        {code: 'es', label: 'Español'},
        {code: 'nl', label: 'Nederlands'}
      ]
    };
  },
  computed: {
    currentLocale() {
      return (this.$i18n.locale || 'en').toLowerCase();
    }
  },
  methods: {
    flagSrc(code) {
      try {
        return require(`@/assets/flags/${code}.svg`);
      } catch (e) {
        return require('@/assets/flags/en.svg');
      }
    },
    select(code) {
      if (code !== this.currentLocale) {
        this.changeLanguage(code, true); // persist=true → localStorage, survives reload
      }
      document.activeElement.blur(); // close the hoverable dropdown
    }
  }
};
</script>

<style scoped>
.lang-selector .navbar-link {
  display: flex;
  align-items: center;
  gap: 7px;
}
.lang-selector .navbar-link.is-arrowless::after { display: none; }
.lang-flag {
  height: 13px;
  width: 20px;
  object-fit: cover;
  border-radius: 2px;
  box-shadow: 0 0 0 1px rgba(15, 17, 22, 0.08);
  display: block;
}
.lang-code {
  font-size: 0.8rem;
  font-weight: 600;
  letter-spacing: 0.02em;
}
.navbar-dropdown .navbar-item {
  display: flex;
  align-items: center;
  gap: 9px;
}
.navbar-dropdown .navbar-item.is-active {
  background: #e4ecfb;
  color: #17509e;
}
</style>
